import { Base } from "@studiometa/js-toolkit";
import Aos from "aos/dist/aos.js";
import LargeText from "../atoms/LargeText.js";
class Site extends Base {
  mounted() {
    this.body = document.querySelector("body");
    this.currentLink = null;
    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      threshold: 0.5
    });
    this.$refs.marquee.forEach((target) => {
      observer.observe(target);
    });
    Aos.init({ once: true });
  }
  checkIntersection(entries) {
    if (entries[0].isIntersecting) {
      const { id } = entries[0].target;
      if (this.currentLink) {
        this.currentLink.classList.remove("menu__link--current");
      }
      this.currentLink = document.querySelector(`[href='/#${id}'`);
      this.currentLink.classList.add("menu__link--current");
    }
  }
  onBurgerClick() {
    this.body.classList.toggle("display-menu");
  }
  onMenuLinkClick() {
    this.body.classList.remove("display-menu");
  }
}
Site.config = {
  name: "Site",
  refs: ["burger", "menuLink[]", "marquee[]"],
  options: {
    activeBreakpoints: {
      type: String,
      default: "xxs xs s m"
    }
  },
  components: {
    LargeText
  }
};
export {
  Site as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
